import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { viewRoleApi } from "../../api/roleApi";

const RoleView = () => {
  const navigate = useNavigate();
  const location = useLocation();
    const id  = location.state.roleId || {};

  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchRole = async () => {
      try {
        setLoading(true);
        setError("");

        const response = await viewRoleApi(id);


        const roleData = response?.data?.role || response?.data;

        setRole(roleData);
      } catch (error) {
        console.error("View role error:", error);

        setError(error?.response?.data?.message || "Failed to load role");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchRole();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="container-fluid py-4">
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status" />

          <p className="mt-3 mb-0">Loading role...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container-fluid py-4">
        <div className="alert alert-danger">{error}</div>

        <button
          className="btn btn-secondary"
          onClick={() => navigate("/admin/roles")}
        >
          Back
        </button>
      </div>
    );
  }

  if (!role) {
    return (
      <div className="container-fluid py-4">
        <div className="alert alert-warning">Role not found</div>

        <button
          className="btn btn-secondary"
          onClick={() => navigate("/admin/roles")}
        >
          Back
        </button>
      </div>
    );
  }

  return (
    <div className="container-fluid py-4">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="mb-1">View Role</h4>
        </div>
      </div>

      {/* Role Information */}
      <div className="card shadow-sm mb-4">
        <div className="card-header">
          <h5 className="mb-0">Role Information</h5>
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="text-muted">Role Name</label>

              <div className="fw-semibold">{role?.name || "-"}</div>
            </div>

            <div className="col-md-6 mb-3">
              <label className="text-muted">Role ID</label>

              <div className="fw-semibold">{role?._id || "-"}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Permissions */}
      <div className="card shadow-sm">
        <div className="card-header">
          <h5 className="mb-0">Permissions</h5>
        </div>

        <div className="card-body">
          {!Array.isArray(role?.permissions) ||
          role.permissions.length === 0 ? (
            <div className="text-muted text-center py-4">
              No permissions found
            </div>
          ) : (
            <div className="row">
              {role.permissions.map((permission, index) => (
                <div
                  className="col-md-4 col-lg-6 mb-3"
                  key={permission?.permissionId || index}
                >
                  <div className="border rounded p-3 h-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <span>
                        {permission?.name ||
                          permission?.permissionName ||
                          permission?.title ||
                          permission?.permissionId ||
                          "-"}
                      </span>

                      {permission?.enabled ? (
                        <span className="badge bg-success">Enabled</span>
                      ) : (
                        <span className="badge bg-secondary">Disabled</span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RoleView;
